import { HOTLINE_NUMBER } from '@/constants'
import { Trans } from 'react-i18next'
import AlertContainer from './AlertContainer'

const MaintenanceModeAlert = () => (
  <AlertContainer
    type="alert"
    alertColor="blue"
    height="small"
    noOverlay
    alertText={
      <Trans ns="others" i18nKey="maintenanceMode" emergencyLine={HOTLINE_NUMBER}>
        Vehicle is in maintenance mode. Please receive further instructions on the hotline{' '}
        <strong>{{ emergencyLine: HOTLINE_NUMBER } as unknown as React.ReactNode}</strong>
      </Trans>
    }
  />
)

export default MaintenanceModeAlert
